import { Stack, Typography, Box } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';

import { PulseRatebar } from './pulseRatebar'
import { BreathingRatebar } from './breathingRatebar'
import { Systolicbpbar } from './systolicbpbar'
import { Diastolicbpbar } from './diastolicbpbar'
import { MstressIndexBar } from './mstressindexbar'
import { CardiacWorkloadBar } from './cardiacworkloadbar'
import { HeartRateVariabilityBar } from './heartratevariabilitybar'
import { VascularCapacityBar } from './vascularcapacitybar'
import { FaceSkinAgeBar } from './faceSkinAgebar'
import { BodyShapeIndexBar } from './bodyshapeindexbar'
import { BodyMassindexBar } from './bodymassindexbar'
import { WaistHeightBar } from './waistheightbar'
import { CardiovascularRiskbar } from './cardiovascularriskbar'
import React from 'react';


export const AnalysisCard = ({ title, vitalStatus, vitalSignInitials, resultVal, irregularHbeat, barsVal, details, keyName }) => {

    const isSmallScreen = useMediaQuery(theme => theme.breakpoints.down('sm'));
    const isGalaxyFold = useMediaQuery('(max-width:280px)');


    return (
        <Box minHeight='323px' className='slider-box'>
            <Stack display='flex' flexDirection='row' justifyContent='space-between'>
                {/* Analysis Info Box Satrts */}
                <Box>
                    <Typography
                        color="black"
                        variant="h4" component="h4" fontWeight="bold"
                        sx={{
                            fontWeight: "600",
                            fontSize: isGalaxyFold ? '20px' : isSmallScreen ? '20px' : '20px',
                        }}
                    >
                        {title}
                    </Typography>
                    <Typography
                        color="black"
                        variant="h4" component="h4" fontWeight="bold"
                        sx={{
                            fontWeight: "600",
                            fontSize: isGalaxyFold ? '12px' : isSmallScreen ? '12px' : '12px',
                        }}
                    >
                        Top 55% of all women
                    </Typography>

                    <Box display='flex' flexDirection='row' alignItems='end' marginTop='10px'>
                        <Typography
                            color="black"
                            variant="h4" component="h4" fontWeight="bold"
                            sx={{
                                fontWeight: "700",
                                fontSize: isGalaxyFold ? '25px' : isSmallScreen ? '25px' : '25px',
                            }}
                        >
                            {typeof resultVal === 'object' ? `${resultVal[0].systolic_blood_pressure}/${resultVal[1].diastolic_blood_pressure}` : Number(Math.ceil(resultVal))}
                        </Typography>
                        <Typography
                            color="black"
                            variant="h4" component="h4" fontWeight="bold"
                            sx={{
                                fontWeight: "600", paddingLeft: '6px', paddingBottom: '6px',
                                fontSize: isGalaxyFold ? '10px' : isSmallScreen ? '10px' : '10px',
                            }}
                        >
                            {vitalSignInitials}
                        </Typography>
                    </Box>
                    <Typography
                        color="black"
                        variant="h4" component="h4" fontWeight="bold"
                        sx={{
                            fontWeight: "600",
                            fontSize: isGalaxyFold ? '12px' : isSmallScreen ? '12px' : '12px',
                        }}
                    >
                        Irregular heartbeats: {irregularHbeat}
                    </Typography>
                </Box>
                {/* Analysis Info Box Ends */}

                <Box display='flex' flexDirection='column'>
                    {/* Wave Chart Starts */}
                    <svg xmlns="http://www.w3.org/2000/svg" width="117" height="47" viewBox="0 0 117 47" fill="none">
                        <path d="M2 45V45C21.9554 42.2268 39.3601 30.0274 48.774 12.2149L51.891 6.31717C55.1715 0.110054 64.0099 -0.0362423 67.494 6.05891L73.2738 16.1702C82.0967 31.6052 97.4419 42.2076 115 45V45" stroke="#A1A0A0" stroke-opacity="0.54" stroke-width="3" stroke-linecap="round" />
                    </svg>
                    <svg xmlns="http://www.w3.org/2000/svg" width="117" height="4" viewBox="0 0 117 4" fill="none">
                        <path d="M2 2L115 2.00001" stroke="#A6E177" stroke-width="3" stroke-linecap="round" />
                    </svg>
                    {/* Wave Chart Ends */}



                    <Typography
                        color="#A6E177"
                        variant="p" component="p" fontWeight="bold"
                        sx={{
                            fontWeight: "600",
                            textAlign: 'center',
                            fontSize: isGalaxyFold ? '12px' : isSmallScreen ? '12px' : '12px',
                        }}
                    >
                        {vitalStatus}
                    </Typography>
                </Box>

            </Stack>

            {/* Range Bars Starts */}
            <Stack className="custom-ranges" marginTop={1}>

                {/* Ranges List */}

                {keyName === 'pulserate' ? (
                    <PulseRatebar rangeVal={Number(Math.ceil(resultVal))} />
                ) : null}

                {keyName === 'breathingrate' ? (
                    <BreathingRatebar rangeVal={Number(Math.ceil(resultVal))} />
                ) : null}

                {keyName === 'systolic_blood_pressure' ? (
                    <Systolicbpbar rangeVal={Number(Math.ceil(resultVal))} />
                ) : null}


                {keyName === 'diastolic_blood_pressure' ? (
                    <Diastolicbpbar rangeVal={Number(Math.ceil(resultVal))} />
                ) : null}


                {keyName === 'mentalstressindex' ? (
                    <MstressIndexBar barsValues={barsVal} rangeVal={Number(Math.ceil(resultVal))} />
                ) : null}

                {keyName === 'cardiacworkload' ? (
                    <CardiacWorkloadBar rangeVal={Number(Math.ceil(resultVal))} />
                ) : null}

                {keyName === 'heartratevariability' ? (
                    <HeartRateVariabilityBar rangeVal={Number(Math.ceil(resultVal))} />
                ) : null}

                {keyName === 'vascularcapacity' ? (
                    <VascularCapacityBar rangeVal={Number(Math.ceil(resultVal))} />
                ) : null}

                {keyName === 'faceskinage' ? (
                    <FaceSkinAgeBar rangeVal={Number(Math.ceil(resultVal))} />
                ) : null}

                {keyName === 'bodyshapeindex' ? (
                    <BodyShapeIndexBar rangeVal={Number(Math.ceil(resultVal))} />
                ) : null}

                {keyName === 'bodymassindex' ? (
                    <BodyMassindexBar rangeVal={Number(Math.ceil(resultVal))} />
                ) : null}

                {keyName === 'waistheight' ? (
                    <WaistHeightBar rangeVal={Number(Math.ceil(resultVal))} />
                ) : null}

                {keyName === 'cardiovasculardiseaserisk' ? (
                    <CardiovascularRiskbar rangeVal={Number(Math.ceil(resultVal))} />
                ) : null}

                {/* Ranges List / */}


            </Stack>
            {/* Range Bars Ends */}

            <Box marginTop={2}>
                <Typography
                    color="black"
                    variant="p" component="p" fontWeight="bold"
                    sx={{
                        fontWeight: "400",
                        fontSize: isGalaxyFold ? '13px' : isSmallScreen ? '13px' : '13px',
                    }}
                >
                    {details}
                </Typography>
            </Box>


        </Box>
    );

}